module.exports = __webpack_public_path__ + "img/dr-jordan-mouw-mouw-family-chiropractic.670c2502.jpg";